module.exports = __webpack_public_path__ + "static/media/44546785_2199899953418517_590116819864387584_o-thumb.2bdb4ae3.jpg";